/**
 * Faction system — event-based favor, independent bonuses per tier
 */

import type { GameState, FactionId } from '../state.js';
import { FACTION_DEFS, FAVORABILITY_TIERS, FACTION_EVENTS } from '../data/factions.js';
import type { FactionEventDef } from '../data/factions.js';

/** Get combined multiplicative bonus from ALL factions for a given effect type */
export function getAllFactionBonus(state: GameState, effectType: string): number {
  let mult = 1;
  for (const fId of ['illuminati', 'grey', 'mib_resistance'] as FactionId[]) {
    const rel = state.faction?.relations[fId];
    if (!rel) continue;
    const def = FACTION_DEFS.find(f => f.id === fId);
    if (!def) continue;
    for (const b of def.bonuses) {
      if (b.effectType === effectType && rel.tier >= b.tierRequired) {
        mult *= (1 + b.effectValue);
      }
    }
  }
  return mult;
}

/** Calculate favor tier (1-5) from raw favorability value */
export function calcFavorTier(favorability: number): 1 | 2 | 3 | 4 | 5 {
  for (let i = FAVORABILITY_TIERS.length - 1; i >= 0; i--) {
    if (favorability >= FAVORABILITY_TIERS[i]) return (i + 1) as 1 | 2 | 3 | 4 | 5;
  }
  return 1;
}

/** Pick a random faction event */
export function pickRandomEvent(): FactionEventDef {
  return FACTION_EVENTS[Math.floor(Math.random() * FACTION_EVENTS.length)];
}
